'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdChromeReaderMode = function MdChromeReaderMode(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 31.6v-21.6h-15v21.6h15z m0-25q1.3 0 2.3 1.1t1.1 2.3v21.6q0 1.4-1.1 2.4t-2.3 1h-30q-1.3 0-2.3-1t-1.1-2.4v-21.6q0-1.3 1.1-2.3t2.3-1.1h30z m-13.4 17.5h11.8v2.5h-11.8v-2.5z m0-8.2h11.8v2.5h-11.8v-2.5z m0 4.1h11.8v2.5h-11.8v-2.5z' })
        )
    );
};

exports.default = MdChromeReaderMode;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/chrome-reader-mode.js
// module id = 2725
// module chunks = 0